import * as React from "react";
function SvgChevronLeftSm(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M8.24 11.986a1.15 1.15 0 01.39-.865l5.576-4.905a.924.924 0 011.22 1.386l-4.877 4.29a.125.125 0 000 .188l4.876 4.29a.923.923 0 11-1.22 1.386l-5.573-4.904a1.155 1.155 0 01-.392-.866z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronLeftSm);
export default ForwardRef;
